import { Navigate, useParams } from 'react-router';
import { NotificationType, useGetNotificationQuery } from '../../../../../../generated/core-api/graphql-react-query';
import useGlobalStoreContext from '../../../../../Contexts/GlobalContext/Contexts/GlobalStoreContext/useGlobalStoreContext';
import CardCommentNotify from './CardCommentNotif';

export default function NotificationPage() {
  const { id } = useParams<'id'>();
  const notification = useGetNotificationQuery({ id: id || '' });
  const { projectId: [projectId, setProjectId] } = useGlobalStoreContext();
  if (notification.isLoading) {
    return <div>Loading...</div>;
  }

  if (notification.isError) {
    return <div>Error</div>;
  }

  if (!notification.data) {
    return <div>Not found</div>;
  }

  const notif = notification.data.getNotification;

  switch (notif.event.eventType) {
    case NotificationType.NewContent:
      if (notif.event.projectId && notif.event.projectId !== projectId) {
        setProjectId(notif.event.projectId);
      }
      return <Navigate to={`/projects/${notif.event.projectId}/cards/${notif.event.cardId}`} />;
    case NotificationType.ProjectAssigned:
      if (notif.event.projectId && notif.event.projectId !== projectId) {
        setProjectId(notif.event.projectId);
      }
      return <Navigate to="/home" />;
    case NotificationType.CardComment:
      if (notif.event.card?.scopes.items && notif.event.card?.scopes.items.length > 0) {
        const currentProjectId = notif.event.card?.scopes.items.find((p) => p.projectId === projectId)?.projectId;
        const defaultProject = notif.event.card?.scopes.items[0]?.projectId;
        return (
          <CardCommentNotify
            defaultProject={defaultProject ?? null}
            currentProjectId={currentProjectId ?? null}
            cardId={notif.event.cardId}
          />
        );
      }
      throw new Error('Card not found');
    case NotificationType.AvailableCommand:
      if (notif.event.command) {
        if (notif.event.projectId && notif.event.projectId !== projectId) {
          setProjectId(notif.event.projectId);
        }
        return <Navigate to={`/commands?search=${notif.event.command.text}`} />;
      }
      return <div>Not found</div>;

    case NotificationType.ContentRequestCommented:
    case NotificationType.ContentRequestCreated:
    case NotificationType.ContentRequestUpdated:
      return <Navigate to={`/requests/${notif.event.contentRequestCounter}`} />;

    default:
      return <div>Not found</div>;
  }
}
